import React, { useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { MODAL_KEYS } from '_constants/modals';
import { theme } from '_constants/theme';
import { selectModalDataByKey, selectModalVisibleByKey } from '_store/modals/selector';
import { hideModal } from '_store/modals/slice';
import { selectActiveOrderId } from '_store/order/selector';
import { selectError, selectForm, selectUpdating } from '_store/tasks/selector';
import { refreshForm, updateTask } from '_store/tasks/slice';
import { selectCustomerId } from '_store/user/selector';

import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';
import SendTaskResponseForm from 'components/composed/forms/SendTaskResponseForm';

const StyledModalBody = styled(Modal.Body)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.spaces.large}px;
`;

const StyledCloseActionContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: ${-theme.spaces.large3X}px;
  right: 0;
  font-family: 'Inter';
  font-style: normal;
  font-size: ${theme.fontSizes.regular}px;
  font-weight: 400;
  color: ${theme.colors.white};
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  margin-right: ${theme.spaces.small2X}px;
`;

const SendTaskResponseModal = () => {
  const dispatch = useDispatch();
  const visible = useSelector(selectModalVisibleByKey(MODAL_KEYS.taskResponseSend));
  const data = useSelector(selectModalDataByKey(MODAL_KEYS.taskResponseSend));
  const updating = useSelector(selectUpdating);
  const formValues = useSelector(selectForm);
  const error = useSelector(selectError);
  const customerId = useSelector(selectCustomerId);
  const orderId = useSelector(selectActiveOrderId);

  const handleClose = () => {
    dispatch(hideModal({ key: MODAL_KEYS.taskResponseSend }));
  };

  const handleSubmit = useCallback(
    (values) => {
      if (values) {
        const { productId, id: taskId } = data;
        dispatch(refreshForm({ ...values }));
        dispatch(updateTask({ customerId, orderId, productId, taskId, body: data }));
      }
    },
    [customerId, orderId, data]
  );

  return (
    <Modal
      dialogClassName="response-send-modal"
      show={visible}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <StyledModalBody>
        <StyledCloseActionContainer onClick={handleClose}>
          <StyledIconContainer>
            <Icon alias={ICON_ALIASES.close} color={theme.colors.white} />
          </StyledIconContainer>
          Close
        </StyledCloseActionContainer>
        <Text
          size={theme.fontSizes.largeX}
          weight={700}
          color={theme.colors.gray.primary}
          bottomSpace={theme.spaces.medium}
        >
          Send Message
        </Text>
        <SendTaskResponseForm
          error={error}
          loading={updating}
          submitDisabled={updating}
          defaultValues={formValues}
          onCancel={handleClose}
          onSubmit={handleSubmit}
        />
      </StyledModalBody>
    </Modal>
  );
};

export default SendTaskResponseModal;
